import React from 'react';

import Rollover from './Rollover';
import { Table, Th, Td } from './Table';
import * as util from './util';

export default class PlayerRollover extends React.Component {
    render() {
        const data = this.props.data;
        const info = data.info;
        const batting = data.battingSummary;
        const bowling = data.bowlingSummary;
        const battingTable = batting && <PlayerBattingTable batting={batting} />;
        const bowlingTable = bowling && <PlayerBowlingTable bowling={bowling} />;
        let photo;
        if (info.photo) {
            photo = (
                <div className="cc-player-photo cc-photo-small">
                    <img src={`/${info.photo}`} />
                </div>
            );
        }
        return (
            <Rollover
                directionInfo={this.props.directionInfo}
                direction={this.props.direction}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
            >
                <div className="cc-panel-bar">
                    {photo}
                    <div className="cc-panel-bar-content">
                        <h2>
                            {info.fname} {info.lname}
                        </h2>
                        <div>{info.nname}</div>
                    </div>
                </div>
                <div className="cc-panel-subbar">Batting</div>
                {battingTable}
                <div className="cc-panel-subbar">Bowling</div>
                {bowlingTable}
                <div className="cc-panel-buttons cc-text-center">
                    <a className="cc-flat-button" href={`/players/${info.pid}`}>
                        Full Profile
                    </a>
                </div>
            </Rollover>
        );
    }
}

class PlayerBattingTable extends React.Component {
    render() {
        let batting = this.props.batting;
        if (batting && batting.length > 0) {
            batting = batting[0];
        }
        return (
            <Table compact>
                <thead>
                    <tr>
                        <Th>Innings</Th>
                        <Th>Not Outs</Th>
                        <Th>Runs</Th>
                        <Th>Best</Th>
                        <Th>100s</Th>
                        <Th>50s</Th>
                        <Th>Average</Th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <Td>{batting.innings}</Td>
                        <Td>{batting.notouts}</Td>
                        <Td>{batting.runs}</Td>
                        <Td className={`cc-runs-${batting.bestisout.toLowerCase().replace(' ', '_')}`}>{batting.bestruns}</Td>
                        <Td>{batting.r100s}</Td>
                        <Td>{batting.r50s}</Td>
                        <Td>{util.dp(batting.average)}</Td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}

const PlayerBowlingTable = ({ bowling }) => {
    if (bowling && bowling.length > 0) {
        bowling = bowling[0];
    }
    return (
        <Table compact>
            <thead>
                <tr>
                    <Th>Overs</Th>
                    <Th>Maidens</Th>
                    <Th>Runs</Th>
                    <Th>Wickets</Th>
                    <Th>Average</Th>
                    <Th>S/R</Th>
                    <Th>E/R</Th>
                    <Th>Best</Th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <Td>{bowling.overs}</Td>
                    <Td>{bowling.maidens}</Td>
                    <Td>{bowling.runs}</Td>
                    <Td>{bowling.wickets}</Td>
                    <Td>{util.dp(bowling.average)}</Td>
                    <Td>{util.dp(bowling.strike)}</Td>
                    <Td>{util.dp(bowling.economy)}</Td>
                    <Td>
                        {bowling.best_wickets} for {bowling.best_runs}
                    </Td>
                </tr>
            </tbody>
        </Table>
    );
};



// WEBPACK FOOTER //
// ./src/components/PlayerRollover.jsx